import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'

const styles = theme => ({
  root: {
    width: 320,
    marginLeft: 38,
    marginBottom: 30,
    [theme.breakpoints.down('md')]: {
      width: 250,
      marginLeft: 25,
    },
    [theme.breakpoints.down('sm')]: {
      width: 200,
      marginLeft: 22,
    },
  },
  button: {
    marginTop: 20,
    color: theme.palette.primary.second,
  },
  coloredBandana: {
    backgroundColor: theme.palette.primary.main,
    height: 12,
  },
})

class BlogSidebar extends React.Component {
  render() {
    const { classes } = this.props
    return (
      <div>
        <div className={classes.root}>
          <div className={classes.coloredBandana} />
          <Paper style={{ padding: 22 }} elevation={1}>
            <Typography variant="subtitle2" component="h5" gutterBottom>
              About
            </Typography>
            <Typography component="p">
              This blog is curated by the team behind Auto Club Reviews. We
              document our progress, announce product updates and publish on
              topics such as what does a car need, what you should buy first and
              what are your best options.
            </Typography>
            <Button className={classes.button} href={'/who-we-are'}>
              <span>Who we are</span>
            </Button>
          </Paper>
        </div>
        <div className={classes.root}>
          <div className={classes.coloredBandana} />
          <Paper style={{ padding: 22 }} elevation={1}>
            <Typography variant="subtitle2" component="h5" gutterBottom>
              Let us help you!
            </Typography>
            <Typography component="p">
              Let us know on which topic your next reading on our site, should
              be. Share with us ideas that you think others can also enjoy, and
              products you find practical for our community.
            </Typography>
            <Button className={classes.button} href={'/request-a-review'}>
              <span>Request a review</span>
            </Button>
          </Paper>
        </div>
        <div className={classes.root}>
          <div className={classes.coloredBandana} />
          <Paper style={{ padding: 22 }} elevation={1}>
            <Typography variant="subtitle2" component="h5" gutterBottom>
              Become a featured author!
            </Typography>
            <Typography component="p">
              Join our community and get your work or ideas featured in front of
              thousands of people, who share the same interests as you.
            </Typography>
            <Button className={classes.button} href={'/write-for-us'}>
              <span>Write for us</span>
            </Button>
          </Paper>
        </div>
      </div>
    )
  }
}

BlogSidebar.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(BlogSidebar)



// WEBPACK FOOTER //
// ./src/components/Blog/BlogSidebar.js